import { ConfigProvider, theme } from 'antd';
import type { ThemeConfig } from 'antd';
import type { FC, ReactNode } from 'react';

import { baseColors, fontColors } from '@/shared/theme/tokens';

import frFR from 'antd/locale/fr_FR';

const antdTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorBgContainer: baseColors.bg,
    colorBgElevated: baseColors.segBg,
    colorText: fontColors.primary,
    colorTextHeading: fontColors.primary,
    colorTextPlaceholder: fontColors.muted,
    colorBorder: baseColors.border,
    fontFamily: 'Manrope, sans-serif',
    fontSize: 14,
    borderRadius: 6,
  },
  components: {
    Table: {
      headerBg: baseColors.segBg,
      headerColor: fontColors.primary,
      colorBgContainer: 'transparent',
      colorText: fontColors.primary,
      borderColor: 'rgba(0, 0, 0, 0.06)',
      headerBorderRadius: 8,
      cellPaddingBlock: 12,
      cellPaddingInline: 12,
      fontWeightStrong: 600,
      headerSplitColor: 'rgba(240, 240, 240, 0.15)',
      rowHoverBg: 'transparent',
      headerFilterHoverBg: 'transparent',
      cellFontSize: 12,
      fontSizeSM: 12,
      rowSelectedBg: 'transparent',
      rowSelectedHoverBg: 'transparent',
      headerSortActiveBg: baseColors.selectedBg,
      headerSortHoverBg: baseColors.selectedBg,
    },
    Input: {
      colorBgContainer: baseColors.bg,
      colorText: fontColors.primary,
      colorTextPlaceholder: fontColors.muted,
      colorBorder: baseColors.border,
      addonBg: baseColors.segBg,
    },
    InputNumber: {
      colorBgContainer: baseColors.border,
      colorText: fontColors.primary,
      colorTextPlaceholder: fontColors.muted,
      colorBorder: baseColors.border,
      handleBg: baseColors.border,
      handleVisible: true,
      handleBorderColor: baseColors.border,
    },
    Checkbox: {
      colorBgContainer: 'transparent',
      colorBorder: fontColors.primary,
      colorPrimary: '#4096ff',
    },
    Tooltip: {
      colorBgSpotlight: baseColors.segBg,
      colorTextLightSolid: fontColors.primary,
    },
  },
};

interface AntdThemeProviderProps {
  children: ReactNode;
}

export const AntdThemeProvider: FC<AntdThemeProviderProps> = ({ children }) => {
  return (
    <ConfigProvider theme={antdTheme} locale={frFR}>
      {children}
    </ConfigProvider>
  );
};
